import ReviewInformation from './reviewinformation'

export default ReviewInformation
